import React, { Component } from 'react';
import { Button } from 'react-materialize';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

class NotFound extends Component {

	render() {
		return (
			<div className="pilotly-notfound">
				<div>
					<h1>
						<FormattedMessage
							id="not_found.message"
							defaultMessage={"Sorry, we couldn't find that page."}
						/>
					</h1>
				</div>
				<div>
					<Link to='/'>
						<Button>
							<FormattedMessage
								id="not_found.button.home"
								defaultMessage={"Go Home"}
							/>
						</Button>
					</Link>
				</div>
			</div>
		);
	}
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/NotFound.js